import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-identification-column',
  templateUrl: './identification-column.component.html',
  styleUrls: ['./identification-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdentificationColumnComponent {
  configs = [
    {
      label: null,
      description: 'LUAN SOUSA',
      mask: null,
    },
    {
      label: null,
      description: '437.191.2218-44',
      mask: '000.000.000-00',
    },
  ];
}
